import classNames from 'classnames/bind';
import React, { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';

import NotFound from '~/views/404';
import Layout from '~/views/Layout';

import style from './index.scss';

const cx = classNames.bind(style);

export default function ErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    setTimeout(() => {
      if (process.env.NODE_ENV !== 'development') {
        window.location.reload();
      }
    }, 5000);
  }, []);

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return (
        <Layout>
          <NotFound />
        </Layout>
      );
    }

    if (error.status === 403) {
      return (
        <div className={cx('ErrorBoundary')}>
          <img alt="Error logo" src="/img/piczel-error.png" />
          <h1>Access Denied</h1>

          <p>You do not have permission to view this resource.</p>
        </div>
      );
    }
  }

  return (
    <div>
      <div className={cx('ErrorBoundary')}>
        <img alt="Error logo" src="/img/piczel-error.png" />
        <h1>Something went wrong</h1>

        <p>
          There was an error while processing your request, our developers have
          been notified and will be working on a fix shortly.
        </p>
      </div>
    </div>
  );
}
